import { render } from "./OrderDetial.vue?vue&type=template&id=3cd5bc89&scoped=true"
import script from "./OrderDetial.vue?vue&type=script&lang=js"
export * from "./OrderDetial.vue?vue&type=script&lang=js"

import "./OrderDetial.vue?vue&type=style&index=0&id=3cd5bc89&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3cd5bc89"

export default script